import { ComponentChildren } from 'preact';
import { IcoChevronLeft } from '@components/icons';

type SettingsTabProps = {
  title: string;
  onBack(): void;
  children: ComponentChildren;
};

/**
 * A reusable settings tab component with consistent styling and back button
 */
export function SettingsTab({ title, onBack, children }: SettingsTabProps) {
  return (
    <div class="flex flex-col gap-4 an-fade-in-left">
      <button
        class="text-sm text-gray-500 hover:text-gray-700 flex items-center gap-2"
        onClick={onBack}
      >
        <IcoChevronLeft />
        Back
      </button>
      <h3 class="text-lg font-medium">{title}</h3>
      {children}
    </div>
  );
}
